angular.module('admin.recuentos.index', [
    'security.authorization',
    'services.utility',
    'resources.AdminCategory',
    'resources.Category',
    'resources.Article',
    'services.formErrors',
    'chart.js',
    'services.localizedMessages',
    'daterangepicker'
]);

angular.module('admin.recuentos.index').config(["$stateProvider", function ($stateProvider) {

    $stateProvider
        .state('admin.recuentos', {
            url: '/recuentos',
            title: 'Admin / Recuentos',
            views: {
                'main@': {
                    template: require('./admin-recuento.tpl.html'),
                    controller: 'AdminRecuentosCtrl'
                }
            }
        });
}]);

angular.module('admin.recuentos.index').controller('AdminRecuentosCtrl',
    ["$scope", "$state", "AdminCategory", "searchService", "Category", "Article", "localizedMessages", "formErrors", "$location", function ($scope, $state, AdminCategory, searchService, Category, Article, localizedMessages, formErrors, $location) {
        $scope.localizedMessages = localizedMessages;

        var generateCategoryOptions = function (items, container) {
            angular.forEach(items, function (item, key) {
                if (!item.path) {
                    return;
                }
                var depth = item.path.split('/').filter(Boolean).length;
                var indent = (new Array(5)).join(String.fromCharCode(160));
                container.push({
                    _id: item.id,
                    path: item.path,
                    sefriendly: item.sefriendly,
                    parent: item.parent,
                    name: item.name,
                    _name: (new Array(depth)).join(indent) + item.name
                });
                if (item.children) {
                    generateCategoryOptions(item.children, container);
                }
            });
            return container;
        };

        searchService.setRedirectBase('/admin/recuentos');

        $scope.q = '';

        $scope.period_type = 'month';

        $scope.showCategory = false;

        $scope.categoryName = null;

        $scope.hasEditedName = false;

        $scope.categories = {};

        $scope.diagramData = [[]];

        $scope.orderByField = 'category';
        
        $scope.reverseSort = true;

        $scope.onSelect = searchService.onSelect;

        $scope.changeDiagramType = changeDiagramType;


        var options = [
            {
                _id: 0,
                path: null,
                sefriendly: null,
                parent: null,
                name: 'Root',
                _name: 'Root'
            }
        ];

        Category.getPermittedTree().$promise.then(function (data) {
          $scope.options = generateCategoryOptions(data, options);
          if ($scope.options.length > 0)
            $scope.showCategory = true;
        });

        // AdminCategory.getTree(function (data) {
        //     $scope.options = generateCategoryOptions(data, options);
        //     if ($scope.options.length > 0)
        //         $scope.showCategory = true;
        // });

        $scope.rootUrl = '';
        $scope.data = {
            name: '',
            sefriendly: '',
            parent: ''
        };


        $scope.changedParent = function () {
            if ($scope.data.parent) {
                $scope.categoryName = $scope.data.parent.name;
            }
        };


        $scope.min_date = threeMonthsBack();
        $scope.max_date = getCurrentDate();

        //$scope.series = ['Articles'];
        console.log($scope.period_type)

        $scope.getAllArticlles = Article.getAllArticles({
            min_date: $scope.min_date,
            max_date: $scope.max_date,
            period_type : $scope.period_type
        }, fillDiagramData);


        $scope.diagramClick = function (points, evt) {

        };

        $scope.datePickerOptions = {
            locale: {
                applyClass: "btn-green",
                applyLabel: "Apply",
                cancelLabel: "Cancel",
                customRangeLabel: "Custom range",
                format: "YYYY-MM-DD",
                fromLabel: "From",
                toLabel: "To"
            },
            ranges: {
                "Last 7 Days": [
                    $scope.min_date,
                    $scope.max_date
                ],
                "Last 30 Days": [
                    getLastMonthDate(),
                    $scope.max_date
                ],
                "Last 3 Months": [
                    threeMonthsBack(),
                    $scope.max_date
                ],
                "Last Year": [
                    oneYearBack(),
                    $scope.max_date
                ]
            }
        };
        $scope.datePicker = {};
        $scope.datePicker.date = {startDate: $scope.min_date, endDate: $scope.max_date};


        $scope.makeDiagram = function () {
            var categories = {};
            angular.forEach($scope.categories.selected, function (value, key) {
                categories[key] = value._id;
            });
            Article.getAllRecuentos(
                {
                    //min_date: convertDateFormat($scope.datePicker.date.startDate),
                    //max_date: convertDateFormat($scope.datePicker.date.endDate),
                    min_date: $scope.datePicker.date.startDate,
                    max_date: $scope.datePicker.date.endDate,
                    categories: categories,
                    period_type: $scope.period_type
                },
                fillDiagramData
            );
        }

        function getLastWeekDate() {

            var date = new Date();
            var dateInt = date.setDate(date.getDate() - 7);
            var lastMontDate = new Date(dateInt);
            var year = lastMontDate.getFullYear();
            var month = lastMontDate.getMonth() + 1;
            if (month < 9)
                month = '0' + month;
            var day = lastMontDate.getDate();
            if (day < 10)
                day = '0' + day;
            return year + '-' + month + '-' + day;

        }

        function getLastMonthDate() {

            var date = new Date();
            var dateInt = date.setMonth(date.getMonth() - 1);
            var lastMontDate = new Date(dateInt);
            var year = lastMontDate.getFullYear();
            var month = lastMontDate.getMonth() + 1;
            if (month < 9)
                month = '0' + month;
            var day = lastMontDate.getDate();
            if (day < 10)
                day = '0' + day;
            return year + '-' + month + '-' + day;

        }

        function threeMonthsBack(){
            var date = new Date();
            date.setMonth(date.getMonth()-3);
            return date.getFullYear() + '-' + (date.getMonth()+1)+'-'+date.getDate()
        }

        function getCurrentDate() {
            var date = new Date();
            var year = date.getFullYear();
            var month = date.getMonth() + 1;
            if (month < 9)
                month = '0' + month;
            var day = date.getDate();
            if (day < 10)
                day = '0' + day;
            return year + '-' + month + '-' + day;

        }

        function oneYearBack(){
            var date = new Date();
            date.setFullYear(date.getFullYear()-1);
            return date.getFullYear() + '-' + (date.getMonth()+1)+'-'+date.getDate()
        };

        function convertDateFormat(inputDate) {
            inputDate = new Date(inputDate);
            var day = inputDate.getDate();
            var month = inputDate.getMonth();
            var year = inputDate.getFullYear();
            if (month < 9) {
                month = "0" + (month + 1);
            }
            if (day < 10) {
                day = "0" + day;
            }
            return year + "-" + month + "-" + day;
        }

        function fillDiagramData(data) {
            console.log(data.data);
            $scope.labels = [];
            $scope.fechasdif = [];
            $scope.tablearticles = [];
            $scope.tablearticlescat = [];
            $scope.tablearticlescatgraf = [];
            $scope.diagramData = [[]];
            $scope.series = [];
            $scope.series.push("");
            angular.forEach($scope.categories.selected, function (cat) {
                $scope.series.push(cat.name);
                $scope.tablearticlescat = [];
                $scope.tablearticlescatgraf = [];
                var dif = 0;
                var x = 0;
                angular.forEach(data.data, function (value) {

                    angular.forEach(value.count, function (count) {
                        if(cat._id == count.category){
                            console.log("id>"+cat._id+" >name>"+cat.name+"--dif--"+dif+"-x-"+x);
                            dif = count.count - x;
                            if(x > 0){
                                $scope.tablearticlescat.push(dif);    
                            }                            
                            $scope.tablearticlescat.push(count.count);
                            $scope.tablearticlescatgraf.push(count.count);
                            x = count.count;
                        }
                    });
                    
                });
                $scope.diagramData.push($scope.tablearticlescatgraf);
                $scope.tablearticles.push({
                    category: cat.name,
                    count: $scope.tablearticlescat.reverse()
                });                
            });
            
            var ban = 0;
            angular.forEach(data.data, function (value) {
                $scope.labels.push(value.label);
                if(ban > 0){
                 $scope.fechasdif.push("Dif"); 
                }
                $scope.fechasdif.push(value.label);
                ban++;
            });
            console.log("$scope.series->>>>"+JSON.stringify($scope.series));
            $scope.fechasdif.reverse();
        }

        function changeDiagramType(period_type){
            $scope.period_type = period_type;
            $scope.diagramData[0]=[];
        }

    }]);



// WEBPACK FOOTER //
// ./client/src/app/admin/diagrams/recuento.js